var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCheckBoldLtr = function SvgUiCheckBoldLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M91.887 14.363a4.787 4.787 0 0 1 6.741.05 4.72 4.72 0 0 1 .036 6.615l-.085.086-65.871 64.523a4.79 4.79 0 0 1-6.631.059l-.086-.084L1.396 61.165a4.72 4.72 0 0 1 0-6.701 4.79 4.79 0 0 1 6.655-.084l.087.084 21.249 21.12z",
    clipRule: "evenodd"
  })));
};
export default SvgUiCheckBoldLtr;